import * as React from 'react';
import {colors} from "../ui-components";

const svgPodcast = props => {
  const { fill = colors.crederaRed } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14 5.28998V3.22998C18.01 4.13998 21 7.71998 21 12C21 16.28 18.01 19.86 14 20.77V18.71C16.89 17.85 19 15.17 19 12C19 8.82998 16.89 6.14998 14 5.28998ZM3 8.99998V15H7L12 20V3.99998L7 8.99998H3ZM16.5 12C16.5 10.23 15.48 8.70998 14 7.96998V16.02C15.48 15.29 16.5 13.77 16.5 12Z" fill={fill}/>
    </svg>
  );
};

export default svgPodcast;
